export function getMachineStatusColor(status: string): 'green' | 'red' | 'yellow' | 'gray' {
  switch (status) {
    case 'online':
      return 'green'
    case 'warning':
      return 'yellow'
    case 'error':
      return 'red'
    default:
      return 'gray'
  }
}

export function getMachineStatusLabel(status: string): string {
  switch (status) {
    case 'online':
      return 'En ligne'
    case 'offline':
      return 'Hors ligne'
    case 'warning':
      return 'Attention'
    case 'error':
      return 'Erreur'
    default:
      return status
  }
}
